var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAuthGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.528,
    height: 20.527,
    viewBox: "0 0 20.528 20.527",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-auth-google",
    transform: "translate(-462.001 -532.479)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3680",
    "data-name": "Path 3680",
    d: "M18.219,8.641A8.625,8.625,0,0,0,18,6.542H8.164v3.809h5.772a5,5,0,0,1-2.141,3.331l-.019.127,3.109,2.361.216.021a9.932,9.932,0,0,0,3.119-7.549",
    transform: "translate(464.311 534.331)",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3681",
    "data-name": "Path 3681",
    d: "M10.228,17.816a10.1,10.1,0,0,0,6.936-2.486l-3.3-2.508a6.291,6.291,0,0,1-3.631,1.026A6.293,6.293,0,0,1,4.27,9.582l-.123.01L.913,12.044l-.042.115a10.491,10.491,0,0,0,9.357,5.657",
    transform: "translate(462.246 535.191)",
    fill: "#34a853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3682",
    "data-name": "Path 3682",
    d: "M4.516,11.057a6.216,6.216,0,0,1-.349-2.03A6.523,6.523,0,0,1,4.5,7L4.5,6.862,1.225,4.37l-.106.05a10.056,10.056,0,0,0,0,9.214Z",
    transform: "translate(462 533.716)",
    fill: "#fbbc05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3683",
    "data-name": "Path 3683",
    d: "M10.228,3.968A5.865,5.865,0,0,1,14.277,5.5l2.956-2.828a10.174,10.174,0,0,0-7-2.669A10.489,10.489,0,0,0,.871,5.657L4.258,8.233a6.319,6.319,0,0,1,5.97-4.265",
    transform: "translate(462.246 532.479)",
    fill: "#eb4335"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAuthGoogle);
export default __webpack_public_path__ + "static/media/icon-auth-google.0dc4895ee612e7e711d435c9c71cb1c3.svg";
export { ForwardRef as ReactComponent };